<template>
  <svg :viewBox="viewBox" :style="{ strokeWidth }">
    <annotation-graphic
      v-for="(annotation, index) in referenceImage.annotations"
      :key="index"
      :annotation="annotation"
      :scale="scale"
    />
  </svg>
</template>

<script>
  import { ThumbnailResource } from '@/api-resources';
  import AnnotationGraphic from './AnnotationGraphic';

  export default {
    name: 'AnnotationLayer',

    components: {
      AnnotationGraphic,
    },

    props: {
      referenceImage: ThumbnailResource,
    },

    computed: {
      viewBox() {
        return [0, 0, this.referenceImage.originalWidth, this.referenceImage.originalHeight].join(' ');
      },

      scale() {
        return Math.max(this.referenceImage.originalWidth, this.referenceImage.originalHeight) / 1024;
      },

      strokeWidth() {
        return Math.round(this.scale * 10);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';

  svg {
    stroke: var(--primary);
    fill: none;
  }
</style>
